import { useMutation, useQuery } from 'react-apollo';
import produce from 'immer';

import { MeWithPrintAssets } from '../../../../../../../../graphql/queries/account';
import {
  printAssetCreate as printAssetCreateMutation,
  printAssetUpdate as printAssetUpdateMutation,
} from '../../../../../../../../graphql/mutations/print-assets';
import { PricingCategoriesForPrintAssets } from '../../../../../../../../graphql/queries/pricing-categories';

const usePrintAssetForm = ({ printAssetType }) => {
  const { data: { me } = {} } = useQuery(MeWithPrintAssets, {
    variables: {
      search_query: '',
      pricing_category_ids: [],
      print_asset_type: printAssetType,
    },
  });

  const [onPrintAssetCreate] = useMutation(printAssetCreateMutation);
  const [onPrintAssetUpdate] = useMutation(printAssetUpdateMutation);

  const printAssetCreate = async input => {
    const result = await onPrintAssetCreate({
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: PricingCategoriesForPrintAssets,
          variables: {
            print_asset_type: printAssetType,
          },
        },
      ],
      update: (store, { data: { printAssetCreate: response } }) => {
        const { print_asset: printAsset } = response;
        try {
          const data = store.readQuery({
            query: MeWithPrintAssets,
            variables: {
              search_query: '',
              pricing_category_ids: [],
              print_asset_type: printAssetType,
            },
          });

          const updatedData = produce(data, draft => {
            draft.me.print_assets.total += 1;
            draft.me.print_assets.records = [
              printAsset,
              ...data.me.print_assets.records,
            ];
          });

          store.writeQuery({
            query: MeWithPrintAssets,
            variables: {
              search_query: '',
              pricing_category_ids: [],
              print_asset_type: printAssetType,
            },
            data: updatedData,
          });
        } catch (e) {
          //   Do nothing query might not be loaded.
        }

        if (printAsset?.pricing_categories?.records?.length > 0) {
          printAsset?.pricing_categories?.records.forEach(
            ({ pricing_category: category }) => {
              try {
                const data = store.readQuery({
                  query: MeWithPrintAssets,
                  variables: {
                    search_query: '',
                    pricing_category_ids: [category.id],
                    print_asset_type: printAssetType,
                  },
                });

                const updatedData = produce(data, draft => {
                  draft.me.print_assets.total += 1;
                  draft.me.print_assets.records = [
                    printAsset,
                    ...data.me.print_assets.records,
                  ];
                });

                store.writeQuery({
                  query: MeWithPrintAssets,
                  variables: {
                    search_query: '',
                    pricing_category_ids: [category.id],
                    print_asset_type: printAssetType,
                  },
                  data: updatedData,
                });
              } catch (e) {
                //   Do nothing query might not be loaded.
              }
            },
          );
        }
      },
    });

    return result;
  };

  const printAssetUpdate = async input => {
    const result = await onPrintAssetUpdate({
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: PricingCategoriesForPrintAssets,
          variables: {
            print_asset_type: printAssetType,
          },
        },
      ],
    });

    return result;
  };

  return {
    userId: me?.id,
    printAssets: me?.print_assets?.records,
    printAssetCreate,
    printAssetUpdate,
  };
};

export default usePrintAssetForm;
